import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { qrLogotype } from "../../../../../redux/slices/qrSettings";
import { CustomCol, FrameItem } from "../../framesQr/QrFrameItems";
function NewLogoItem({ logoShow }) {
  const logotype = useSelector((state) => state.qrSettings.logotype);
  const dispatch = useDispatch();
  function showHandler() {
    dispatch(qrLogotype(logoShow));
  }
  return (
    <>
      {logoShow && (
        <CustomCol xs={3}>
          <FrameItem
            onClick={showHandler}
            className={classNames(
              "d-flex justify-content-center align-items-center border rounded-1",
              {
                "border-primary": logoShow === logotype,
                "border-border-gray": logoShow !== logotype,
              }
            )}
            style={{ padding: "20%" }}
          >
            <div
              style={{ aspectRatio: "1 / 1", width: "100px" }}
              className="overflow-hidden"
            >
              <img className="w-100" src={logoShow} alt={"upload image"} />
            </div>
          </FrameItem>
        </CustomCol>
      )}
    </>
  );
}
export default NewLogoItem;
